// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SurveyPage.css - Based on Figma Design */

.survey-page {
  width: 100%;
  min-height: 100%;
  background-color: #F4F4F4;
  padding: 0;
}

.survey-loading,
.survey-error {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 18px;
  color: #21262A;
}

.survey-error {
  color: #D32F2F;
}

.survey-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  max-width: 1540px;
  margin: 0;
  padding: 0 50px;
  width: 100%;
  box-sizing: border-box;
}

/* Header */
.survey-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  max-width: 840px;
  text-align: left;
}

.survey-title {
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 900;
  font-size: 48px;
  line-height: 1.2;
  letter-spacing: -0.005em;
  color: #236CFF;
  margin: 0;
}

.survey-description {
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.6;
  color: #21262A;
  margin: 0;
}

/* Questions Container */
.survey-questions-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
  padding: 0;
  background-color: transparent;
  border-radius: 0;
  box-sizing: border-box;
}

/* Individual Question */
.survey-question {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.question-text {
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 1.4;
  letter-spacing: -0.005em;
  color: #21262A;
  margin: 0;
}

/* Question Image */
.question-image {
  display: block;
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 0 auto 16px auto;
}

/* Options - Column Layout (one per row) */
.question-options {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Radio Button Option */
.option-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  position: relative;
}

.option-radio {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.option-radio-custom {
  width: 20px;
  height: 20px;
  border: 2px solid #859299;
  border-radius: 50%;
  background-color: #FFFFFF;
  transition: all 0.2s ease;
  flex-shrink: 0;
  position: relative;
}

.option-radio:checked + .option-radio-custom {
  border-color: #236CFF;
}

.option-radio:checked + .option-radio-custom::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  background-color: #236CFF;
  border-radius: 50%;
}

.option-radio:focus + .option-radio-custom {
  box-shadow: 0 0 0 3px rgba(35, 108, 255, 0.2);
}

.option-text {
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5;
  color: #21262A;
}

/* Horizontal Options Layout (for horizontalMultipleChoice) */
.question-options-horizontal {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: clamp(4px, 2vw, 16px);
  width: 100%;
}

.option-label-horizontal {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: clamp(4px, 1vw, 8px);
  cursor: pointer;
  position: relative;
  flex: 1 1 0;
  min-width: 0;
  padding: clamp(6px, 1.5vw, 12px) clamp(4px, 1vw, 8px);
  border: 1px solid #D5DEE3;
  border-radius: 8px;
  background-color: #FAFAFA;
  transition: all 0.2s ease;
}

.option-label-horizontal:hover {
  border-color: #236CFF;
  background-color: #F0F6FF;
}

.option-label-horizontal:has(.option-radio:checked) {
  border-color: #236CFF;
  background-color: #E8F0FF;
}

.option-text-horizontal {
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 400;
  font-size: clamp(10px, 1.5vw, 13px);
  line-height: 1.4;
  color: #21262A;
  text-align: center;
  word-break: break-word;
  hyphens: auto;
}

/* NPS Question Styles */
.nps-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.nps-labels {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 500;
  font-size: clamp(11px, 1.5vw, 14px);
  color: #5F696F;
}

.nps-label-left,
.nps-label-right {
  flex-shrink: 0;
}

.nps-options {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: clamp(2px, 1vw, 8px);
  width: 100%;
}

.nps-option {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 0;
  min-width: 0;
  cursor: pointer;
  position: relative;
}

.nps-radio {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.nps-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  aspect-ratio: 1;
  max-width: 48px;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 600;
  font-size: clamp(12px, 2vw, 16px);
  color: #21262A;
  background-color: #F4F4F4;
  border: 2px solid #D5DEE3;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.nps-option:hover .nps-number {
  border-color: #236CFF;
  background-color: #F0F6FF;
}

.nps-radio:checked + .nps-number {
  border-color: #236CFF;
  background-color: #236CFF;
  color: #FFFFFF;
}

.nps-radio:focus-visible + .nps-number {
  outline: 2px solid #236CFF;
  outline-offset: 2px;
}

/* Container Question Styles */
.question-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  padding-left: 16px;
  border-left: 3px solid #236CFF;
}

.sub-question {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.sub-question-text {
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.4;
  color: #1d1e1f;
  margin: 0;
}

/* Text Input for text type questions */
.question-text-input {
  width: 100%;
}

.text-answer {
  width: 100%;
  min-height: 100px;
  padding: 16px;
  border: 1px solid #D5DEE3;
  border-radius: 8px;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 16px;
  line-height: 1.5;
  color: #21262A;
  resize: vertical;
  box-sizing: border-box;
}

.text-answer::placeholder {
  color: #859299;
}

.text-answer:focus {
  outline: none;
  border-color: #236CFF;
  box-shadow: 0 0 0 3px rgba(35, 108, 255, 0.1);
}

/* Submit Button */
.survey-submit-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 183px;
  height: 48px;
  padding: 10px 24px;
  background-color: #00254B;
  border: none;
  border-radius: 9999px;
  cursor: pointer;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.75;
  color: #FFFFFF;
  transition: background-color 0.2s ease;
  margin-top: 16px;
}

.survey-submit-btn:hover:not(.survey-submit-btn-disabled) {
  background-color: #001a35;
}

.survey-submit-btn:focus {
  outline: 2px solid #1C60EA;
  outline-offset: 2px;
}

.survey-submit-btn-disabled {
  background-color: rgba(0, 37, 75, 0.4);
  cursor: not-allowed;
}

/* Responsive */
@media (max-width: 900px) {
  .survey-content {
    padding: 0 20px;
  }

  .survey-questions-container {
    padding: 0;
  }

  .survey-title {
    font-size: 36px;
  }

  .question-options {
    flex-direction: column;
    gap: 16px;
  }

}

@media (max-width: 600px) {
  .survey-title {
    font-size: 28px;
  }

  .question-text {
    font-size: 18px;
  }

  .question-container {
    padding-left: 12px;
  }

  .sub-question-text {
    font-size: 14px;
  }
}

`, "",{"version":3,"sources":["webpack://./../shared/styles/Survey.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kFAAkF;EAClF,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,SAAS;EACT,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,UAAU;EACV,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kFAAkF;EAClF,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,kFAAkF;EAClF,gBAAgB;EAChB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,eAAe;EACf,kFAAkF;EAClF,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,uCAAuC;AACvC;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kFAAkF;EAClF,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;AAEF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* SurveyPage.css - Based on Figma Design */\n\n.survey-page {\n  width: 100%;\n  min-height: 100%;\n  background-color: #F4F4F4;\n  padding: 0;\n}\n\n.survey-loading,\n.survey-error {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 18px;\n  color: #21262A;\n}\n\n.survey-error {\n  color: #D32F2F;\n}\n\n.survey-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  max-width: 1540px;\n  margin: 0;\n  padding: 0 50px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Header */\n.survey-header {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  max-width: 840px;\n  text-align: left;\n}\n\n.survey-title {\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 900;\n  font-size: 48px;\n  line-height: 1.2;\n  letter-spacing: -0.005em;\n  color: #236CFF;\n  margin: 0;\n}\n\n.survey-description {\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 1.6;\n  color: #21262A;\n  margin: 0;\n}\n\n/* Questions Container */\n.survey-questions-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 24px;\n  width: 100%;\n  padding: 0;\n  background-color: transparent;\n  border-radius: 0;\n  box-sizing: border-box;\n}\n\n/* Individual Question */\n.survey-question {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n}\n\n.question-text {\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 1.4;\n  letter-spacing: -0.005em;\n  color: #21262A;\n  margin: 0;\n}\n\n/* Question Image */\n.question-image {\n  display: block;\n  max-width: 100%;\n  height: auto;\n  border-radius: 8px;\n  margin: 0 auto 16px auto;\n}\n\n/* Options - Column Layout (one per row) */\n.question-options {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Radio Button Option */\n.option-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  position: relative;\n}\n\n.option-radio {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.option-radio-custom {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #859299;\n  border-radius: 50%;\n  background-color: #FFFFFF;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.option-radio:checked + .option-radio-custom {\n  border-color: #236CFF;\n}\n\n.option-radio:checked + .option-radio-custom::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 10px;\n  height: 10px;\n  background-color: #236CFF;\n  border-radius: 50%;\n}\n\n.option-radio:focus + .option-radio-custom {\n  box-shadow: 0 0 0 3px rgba(35, 108, 255, 0.2);\n}\n\n.option-text {\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1.5;\n  color: #21262A;\n}\n\n/* Horizontal Options Layout (for horizontalMultipleChoice) */\n.question-options-horizontal {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  gap: clamp(4px, 2vw, 16px);\n  width: 100%;\n}\n\n.option-label-horizontal {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: clamp(4px, 1vw, 8px);\n  cursor: pointer;\n  position: relative;\n  flex: 1 1 0;\n  min-width: 0;\n  padding: clamp(6px, 1.5vw, 12px) clamp(4px, 1vw, 8px);\n  border: 1px solid #D5DEE3;\n  border-radius: 8px;\n  background-color: #FAFAFA;\n  transition: all 0.2s ease;\n}\n\n.option-label-horizontal:hover {\n  border-color: #236CFF;\n  background-color: #F0F6FF;\n}\n\n.option-label-horizontal:has(.option-radio:checked) {\n  border-color: #236CFF;\n  background-color: #E8F0FF;\n}\n\n.option-text-horizontal {\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 400;\n  font-size: clamp(10px, 1.5vw, 13px);\n  line-height: 1.4;\n  color: #21262A;\n  text-align: center;\n  word-break: break-word;\n  hyphens: auto;\n}\n\n/* NPS Question Styles */\n.nps-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.nps-labels {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 500;\n  font-size: clamp(11px, 1.5vw, 14px);\n  color: #5F696F;\n}\n\n.nps-label-left,\n.nps-label-right {\n  flex-shrink: 0;\n}\n\n.nps-options {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  gap: clamp(2px, 1vw, 8px);\n  width: 100%;\n}\n\n.nps-option {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1 1 0;\n  min-width: 0;\n  cursor: pointer;\n  position: relative;\n}\n\n.nps-radio {\n  position: absolute;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n}\n\n.nps-number {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  aspect-ratio: 1;\n  max-width: 48px;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 600;\n  font-size: clamp(12px, 2vw, 16px);\n  color: #21262A;\n  background-color: #F4F4F4;\n  border: 2px solid #D5DEE3;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.nps-option:hover .nps-number {\n  border-color: #236CFF;\n  background-color: #F0F6FF;\n}\n\n.nps-radio:checked + .nps-number {\n  border-color: #236CFF;\n  background-color: #236CFF;\n  color: #FFFFFF;\n}\n\n.nps-radio:focus-visible + .nps-number {\n  outline: 2px solid #236CFF;\n  outline-offset: 2px;\n}\n\n/* Container Question Styles */\n.question-container {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 100%;\n  padding-left: 16px;\n  border-left: 3px solid #236CFF;\n}\n\n.sub-question {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n.sub-question-text {\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 1.4;\n  color: #1d1e1f;\n  margin: 0;\n}\n\n/* Text Input for text type questions */\n.question-text-input {\n  width: 100%;\n}\n\n.text-answer {\n  width: 100%;\n  min-height: 100px;\n  padding: 16px;\n  border: 1px solid #D5DEE3;\n  border-radius: 8px;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 16px;\n  line-height: 1.5;\n  color: #21262A;\n  resize: vertical;\n  box-sizing: border-box;\n}\n\n.text-answer::placeholder {\n  color: #859299;\n}\n\n.text-answer:focus {\n  outline: none;\n  border-color: #236CFF;\n  box-shadow: 0 0 0 3px rgba(35, 108, 255, 0.1);\n}\n\n/* Submit Button */\n.survey-submit-btn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 183px;\n  height: 48px;\n  padding: 10px 24px;\n  background-color: #00254B;\n  border: none;\n  border-radius: 9999px;\n  cursor: pointer;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 1.75;\n  color: #FFFFFF;\n  transition: background-color 0.2s ease;\n  margin-top: 16px;\n}\n\n.survey-submit-btn:hover:not(.survey-submit-btn-disabled) {\n  background-color: #001a35;\n}\n\n.survey-submit-btn:focus {\n  outline: 2px solid #1C60EA;\n  outline-offset: 2px;\n}\n\n.survey-submit-btn-disabled {\n  background-color: rgba(0, 37, 75, 0.4);\n  cursor: not-allowed;\n}\n\n/* Responsive */\n@media (max-width: 900px) {\n  .survey-content {\n    padding: 0 20px;\n  }\n\n  .survey-questions-container {\n    padding: 0;\n  }\n\n  .survey-title {\n    font-size: 36px;\n  }\n\n  .question-options {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n}\n\n@media (max-width: 600px) {\n  .survey-title {\n    font-size: 28px;\n  }\n\n  .question-text {\n    font-size: 18px;\n  }\n\n  .question-container {\n    padding-left: 12px;\n  }\n\n  .sub-question-text {\n    font-size: 14px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
